import { BaseSerializer } from "./baseSerializer.ts";
import {FeatureSerializer} from "./featureSerializer.ts";
import {Permission} from "../permission.model.ts";
import {OrganizationSerializer} from "./organizationSerializer.ts"


export class PermissionSerializer extends BaseSerializer {
    public deserialize(data: Record<string, any>): Permission {
        const permission = new Permission();

        this._copyAttributes(permission, data);

        if (data.features) {
            const featureSerializer = new FeatureSerializer();
            permission.features = featureSerializer.deserializeList(data.features);
        }

        if (data.organizations) {
            const organizationSerializer = new OrganizationSerializer();
            permission.organizations = organizationSerializer.deserializeList(data.organizations);
        }

        this.setIsSuperUser(permission)

        return permission;
    }

    private setIsSuperUser(permission: Permission){

        const filteredArray = permission.features.filter(obj => obj.name === '*');

        permission.is_super_user = filteredArray.length > 0;

    }
}
